import { defineField, defineType } from 'sanity'
import { getRegistrationCtaFields } from '../pageBlocks/registrationCta'

export default defineType({
  title: 'Special event registration block',
  name: 'specialEventRegistration',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Text',
      name: 'text',
      type: 'text',
      rows: 3,
    }),
    defineField({
      title: 'Show Countdown',
      name: 'showCountdown',
      type: 'boolean',
      initialValue: false,
      description:
        'Counts down to the start of the next phase. Not shown in the last phase.',
    }),
    defineField({
      title: 'Desktop BG',
      name: 'bgDesktop',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    defineField({
      title: 'Mobile BG',
      name: 'bgMobile',
      type: 'image',
      options: {
        hotspot: true,
      },
    }),
    ...getRegistrationCtaFields(),
  ],
  preview: {
    select: {
      title: 'title',
      media: 'bgDesktop',
    },
    prepare({ title, media }) {
      return {
        title: title || 'Special Event Registration',
        media,
        subtitle: 'Special Event Registration',
      }
    },
  },
})
